module.exports = __webpack_public_path__ + "static/media/kristina-jovcic.1893e6e4.jpg";